import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskLines } from "./shared";
import { STATS } from "../../lib/data";
import heroImg from "../../assets/hero-new.jpg";

export const Hero = ({ onNav }) => {
  const ref = useRef(null);
  const [start, setStart] = useState(false);
  useEffect(() => { const t = setTimeout(() => setStart(true), 150); return () => clearTimeout(t); }, []);

  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const bgScale = useTransform(scrollYProgress, [0, 1], [1.08, 1.22]);
  const contentY = useTransform(scrollYProgress, [0, 1], ["0%", "40%"]);
  const fade = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section ref={ref} id="home" data-testid="hero-section"
      style={{ position: "relative", minHeight: "100vh", display: "flex", alignItems: "center",
        color: "#fff", overflow: "hidden" }}>
      <motion.div style={{ position: "absolute", inset: 0, y: bgY, scale: bgScale, zIndex: 0 }}>
        <img src={heroImg} alt="VLA training" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center 35%" }} />
      </motion.div>
      <div style={{ position: "absolute", inset: 0, zIndex: 1,
        background: "linear-gradient(180deg, rgba(10,10,10,.5) 0%, rgba(10,10,10,.68) 55%, rgba(10,10,10,.95) 100%)" }} />

      <motion.div className="container" style={{ position: "relative", zIndex: 2, y: contentY, opacity: fade }}>
        <div style={{ maxWidth: 800, paddingTop: 110 }}>
          <motion.p className="eyebrow" initial={{ opacity: 0 }} animate={start ? { opacity: 1 } : {}}
            transition={{ delay: 0.1 }} style={{ color: "var(--gold)" }}>
            Victorious Lions Academy
          </motion.p>
          <h1 style={{ fontSize: "clamp(50px,9vw,110px)", textTransform: "uppercase", marginTop: 14, color: "#fff" }}>
            <MaskLines start={start} lines={["Build the Body.", <span key="l2" style={{ color: "var(--gold)" }}>Master the Mind.</span>]} />
          </h1>
          <motion.div initial={{ scaleX: 0 }} animate={start ? { scaleX: 1 } : {}}
            transition={{ delay: 0.7, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            style={{ transformOrigin: "left", width: 130, height: 4, background: "var(--gold)", borderRadius: 2, margin: "26px 0 28px" }} />
          <motion.p initial={{ opacity: 0, y: 20 }} animate={start ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.8 }}
            style={{ fontSize: 18, color: "rgba(255,255,255,0.85)", maxWidth: 540, marginBottom: 40 }}>
            Premium martial arts &amp; functional fitness training for kids and adults — forged through discipline, strength, and community.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={start ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.95 }} style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            <button className="btn btn-gold" onClick={() => onNav("contact")} data-testid="hero-trial-btn">
              Book Free Trial <ArrowRight size={17} />
            </button>
            <button className="btn btn-outline" onClick={() => onNav("programs")} data-testid="hero-programs-btn">
              Explore Programs
            </button>
          </motion.div>

          <motion.div initial={{ opacity: 0 }} animate={start ? { opacity: 1 } : {}} transition={{ delay: 1.15 }}
            style={{ display: "flex", gap: 44, marginTop: 66, flexWrap: "wrap" }}>
            {STATS.map((s) => (
              <div key={s.label}>
                <strong style={{ fontFamily: "'Bebas Neue'", fontSize: 38, color: "var(--gold)", display: "block", lineHeight: 1 }}>{s.value}</strong>
                <span style={{ fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.7)" }}>{s.label}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </motion.div>

      <motion.div style={{ position: "absolute", bottom: 34, left: "50%", x: "-50%", zIndex: 2, opacity: fade,
        color: "rgba(255,255,255,0.65)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase",
        display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
        <span>Scroll</span>
        <span style={{ width: 1, height: 38, background: "rgba(255,255,255,0.4)", overflow: "hidden", position: "relative" }}>
          <motion.span animate={{ y: ["-100%", "100%"] }} transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
            style={{ position: "absolute", inset: 0, background: "var(--gold)" }} />
        </span>
      </motion.div>
    </section>
  );
};
